import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console
    console.error("ErrorBoundary caught an error:", error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // Store the error in localStorage for debugging
    try {
      localStorage.setItem('react_error_boundary', JSON.stringify({
        timestamp: Date.now(),
        error: error.toString(),
        componentStack: errorInfo.componentStack
      }));
    } catch (e) {
      console.error("Failed to store error in localStorage:", e);
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-dark-blue text-white p-4">
          <div className="max-w-md w-full bg-medium-blue p-6 rounded-lg shadow-lg">
            <h1 className="text-xl font-bold text-red-500 mb-4">Something went wrong</h1>
            <p className="mb-4">
              The application encountered an error. Please try the following:
            </p>
            <ul className="list-disc pl-5 mb-4 space-y-2">
              <li>Refresh the page</li>
              <li>Clear browser cache and cookies</li>
              <li>Try again in a few minutes</li>
            </ul>
            <div className="flex space-x-4">
              <button 
                onClick={() => window.location.reload()} 
                className="px-4 py-2 bg-purple-700 hover:bg-purple-800 rounded-md transition"
              >
                Refresh Page
              </button>
              <button 
                onClick={() => window.location.href = '/'}
                className="px-4 py-2 bg-gray-700 hover:bg-gray-800 rounded-md transition"
              >
                Go to Home
              </button>
            </div>
            {this.state.error && (
              <details className="mt-4 p-2 bg-gray-800 rounded overflow-auto max-h-32">
                <summary className="text-yellow-400 cursor-pointer">Error Details (for developers)</summary>
                <pre className="text-xs text-gray-300 p-2">
                  {this.state.error.toString()}
                  <br />
                  {this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 